import { LegalSection, LegalShell } from "./LegalShell";

export function Privacy() {
  return (
    <LegalShell title="Privacy Policy" lastUpdated="May 24, 2026">
      <LegalSection heading="1. Overview">
        <p>
          This policy explains what information BeneCRM collects, how we use it,
          and the choices you have. BeneCRM is a workflow platform for
          employee-benefits brokerages.
        </p>
      </LegalSection>

      <LegalSection heading="2. Information we collect">
        <p>
          We collect account information (name, work email, organization), the
          CRM data you enter (accounts, commitments, touchpoints, documents),
          and usage data needed to operate the service. If you connect an email
          or calendar account, we process the messages and events you grant
          access to.
        </p>
      </LegalSection>

      <LegalSection heading="3. How we use information">
        <p>
          We use your information to provide and improve the service, surface
          client work and renewals, send transactional notifications, and meet
          legal and security obligations. We do not sell your data.
        </p>
      </LegalSection>

      <LegalSection heading="4. Microsoft 365 and other integrations">
        <p>
          When you connect a Microsoft 365 (or other provider) account, BeneCRM
          accesses your mailbox and calendar through the provider&rsquo;s API
          using only the permissions you approve, to read, compose, send, and
          schedule on your behalf within the product. Access and refresh tokens
          are stored encrypted, and you can disconnect a connected account at any
          time to revoke access.
        </p>
      </LegalSection>

      <LegalSection heading="5. Data retention and deletion">
        <p>
          We retain your information for as long as your account is active or as
          needed to provide the service and meet legal requirements. You may
          request deletion of your data, subject to obligations we must retain.
        </p>
      </LegalSection>

      <LegalSection heading="6. Security">
        <p>
          We use industry-standard safeguards including encryption in transit and
          at rest, tenant isolation, and access controls. No method of
          transmission or storage is completely secure, but we work to protect
          your information.
        </p>
      </LegalSection>

      <LegalSection heading="7. Your rights">
        <p>
          Depending on your location, you may have rights to access, correct,
          export, or delete your personal information. Contact us to exercise
          these rights.
        </p>
      </LegalSection>

      <LegalSection heading="8. Contact">
        <p>
          Privacy questions can be sent to{" "}
          <a href="mailto:hello@benecrm.com" className="text-teal hover:underline">
            hello@benecrm.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalShell>
  );
}
